import { useEffect } from "react";

export function useEnterAsTab(formApiRef, domRef) {
  useEffect(() => {
    const root = domRef?.current || document;

    const handleKeyNavigation = (event) => {
      const { key, target } = event;

      if (key !== "Enter" && key !== "Escape") return;

      const reactSelectRoot = target.closest('[class*="react-select"]');

      //Tratamento para quando o componente for um react-select e estiver com o select aberto focado em uma
      //opção para selecionar, o enter não vai passar para o próximo campo e sim deixar selecionar a opção.
      if (key === "Enter" && reactSelectRoot) {
        const menuOpen = document.querySelector(".react-select__menu");
        const optionFocused = document.querySelector(
          ".react-select__option--is-focused",
        );

        //Só ignora quando realmente estiver escolhendo opção
        if (menuOpen && optionFocused) {
          return; // deixa react-select processar Enter
        }
      }

      if (key === "Enter") {
        const isSaveButton =
          target.tagName.toLowerCase() === "button" &&
          ([
            "btnLogin",
            "btnSalvar",
            "btnConfirmar",
            "btnAplicar",
            "btnValidar",
            "btnAdicionarConf", //Esse vai disparar o botão, mas o btnAdicionar não dispara
            //"btnAdicionar", //Fica ruim se colocar
            "btnConsultar",
            "btnFechar",
          ].includes(target.name) ||
            target.getAttribute("data-action") === "salvar");

        if (isSaveButton) {
          //event.preventDefault();
          //event.stopPropagation();
          return;
        }
      }

      //Evita submit no Enter e comportamento padrão no Esc
      event.preventDefault();

      // garante que o evento veio de dentro do root (quando não é document)
      if (
        !root.contains(target) ||
        (key == "Escape" && target.getAttribute("aria-label") === "Close") ||
        (key == "Enter" && target.name == "btnFechar")
      )
        return;

      // pega todos os campos focáveis, exceto botões da paginação
      const elements = Array.from(
        root.querySelectorAll("input, select, textarea, button, [tabindex]"),
      ).filter((el) => {
        const isPaginationButton = el.closest(".rc-pagination") !== null;
        return (
          !el.disabled &&
          el.tabIndex !== -1 &&
          el.offsetParent !== null && // visível
          !isPaginationButton // ignora botões da paginação
        );
      });

      const index = elements.indexOf(target);
      if (index === -1) return;

      if (key === "Enter") {
        //const next = elements[index + 1] || elements[0];
        //next.focus();
        const next = elements[index + 1];
        if (next) next.focus();
        return;
      } else if (key === "Escape") {
        if (index === 0) {
          target.focus();
          return;
        }
        const prev = elements[index - 1];
        prev?.focus();
      }
    };

    root.addEventListener("keydown", handleKeyNavigation);
    return () => root.removeEventListener("keydown", handleKeyNavigation);
  }, [formApiRef, domRef]);
}
